module.exports = __webpack_public_path__ + "static/media/customize-dashboard.dc84b5b3.svg";